<bw-action-card-legacy
  @fadeIn
  [cardConfig]="promotionContestActionCard"
  (ctaClicked)="onCtaClicked()"
></bw-action-card-legacy>
